/**
 * Component Entry
 *
 */

import VisuallyHidden from './VisuallyHidden'
export default VisuallyHidden
export * from './VisuallyHidden'
